module.exports = __webpack_public_path__ + "assets/webgl/LM.2.ed6853ea.jpg";